var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfynitoStep001(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.94,
    height: 49,
    viewBox: "0 0 73.94 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-1w",
    transform: "translate(-459.059 -161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Unione_3",
    "data-name": "Unione 3",
    transform: "translate(459.059 162)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,48h-.059L0,24,12.941,0H61L73.94,24,61,48Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.40239334106445 46.99970245361328 L 72.80428314208984 23.99940490722656 L 60.40240859985352 1.000001192092896 L 13.53800582885742 1.000001192092896 L 1.136114478111267 24.00029754638672 L 13.53799057006836 46.99970245361328 L 60.40239334106445 46.99970245361328 M 60.99929809570312 47.99970245361328 L 12.94109916687012 47.99970245361328 L -4.150390680024429e-07 24.00030136108398 L 12.94109916687012 1.226806602971919e-06 L 60.99929809570312 1.226806602971919e-06 L 73.94039916992188 23.9994010925293 L 60.99929809570312 47.99970245361328 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(490 195)",
    fill: "#fff",
    fontSize: 30,
    fontFamily: "SweetSansPro-Regular, Sweet Sans Pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfynitoStep001);
export default __webpack_public_path__ + "static/media/infynito-step001.3b0478ed3bfe0850f5b8ee0b42a912d4.svg";
export { ForwardRef as ReactComponent };